export const COUNTDOWN_INITIAL_SECONDS = 24 * 60 * 60;
